import DComponentService from "services/api/DComponentService";

const service = new DComponentService()

export const listComponents = (category) => async dispatch => {
    const res = await service.listComponents(category);
    return res && res.data || [];
}